// utils/axiosInstance.js
import axios from "axios";
const baseURL = process.env.REACT_APP_BASE_URL ?? "http://localhost:3040";

console.log("🚀 BASE URL =>", baseURL);

const axiosInstance = axios.create({
  baseURL: `${baseURL}/api`,
});

// Request interceptor to add token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log(
        "Outgoing Authorization header:",
        config.headers.Authorization
      ); // 🔍 debug
    } else {
      console.warn("No token found in localStorage.");
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("401 Unauthorized. Logging out...");
      localStorage.removeItem("token");
      localStorage.removeItem("userRole");
      localStorage.removeItem("tokenExpiry");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
